<template>
  <component :is="tag" :id="headingId" ref="target">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { useSlots } from 'vue'

const props = defineProps<{
  level: string
}>()
const slots = useSlots()
const route = useRoute()
const router = useRouter()
const target = ref()
const targetIsVisible = useElementVisibility(target, {
  threshold: 1,
})
watch(targetIsVisible, onElementVisible)
const tag = computed(() => `h${props.level}`)
const isHeading2 = computed(() => props.level === '2')
const headingText = computed(() => slots.default()?.[0]?.children)
const headingId = computed(() => {
  if (!isHeading2.value) return null

  // Determine if text is a string
  if (typeof headingText.value !== 'string') return null

  return slugifyToAttribute(headingText.value)
})

function onElementVisible(isVisible: boolean) {
  if (isVisible && isHeading2.value && headingId.value) {
    const hash = '#' + headingId.value
    if (hash !== route.hash) router.replace({ hash })
  }
}
</script>
